// ToneBadge + StatusPill — small tinted chips over the NEXOVA tone vocabulary.
//
// ToneBadge: a soft pill (e.g. type/source/flag labels in the ledger).
// StatusPill: a dot + label for an entity status (account active/paused/banned,
// finance-access granted/pending, key enabled/disabled, etc.).

import { cn } from "@/lib/utils";
import { type Tone, toneSoftClass, toneDotClass } from "./tones";

export function ToneBadge({
  tone = "na",
  children,
  className,
}: {
  tone?: Tone;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      data-slot="tone-badge"
      className={cn(
        "inline-flex h-5 w-fit shrink-0 items-center gap-1 rounded-full px-2 text-xs font-medium whitespace-nowrap",
        toneSoftClass[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

export function StatusPill({
  tone = "na",
  children,
  className,
}: {
  tone?: Tone;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      data-slot="status-pill"
      className={cn(
        "inline-flex w-fit items-center gap-1.5 text-xs font-medium text-nx-text-2 whitespace-nowrap",
        className,
      )}
    >
      <span className={cn("size-1.5 rounded-full", toneDotClass[tone])} />
      {children}
    </span>
  );
}
